import {
    Box,
    IconButton,
    Typography,
    TextField,
} from "@mui/material";

import {
    ZoomIn,
    ZoomOut,
    CenterFocusStrong,
} from "@mui/icons-material";

import PropTypes from "prop-types";

export default function PdfToolbar({
                                       pagesCount,
                                       zoom,
                                       pageInput,
                                       setPageInput,
                                       onZoomIn,
                                       onZoomOut,
                                       onGoToPage,
                                       onResetPosition,
                                       currentPage,
                                   }) {
    return (
        <Box
            sx={{
                height: 60,
                minHeight: 60,
                px: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
                background: "#323639",
                borderBottom: "1px solid #444",
                color: "#fff",
            }}
        >
            {/* TOTAL PAGES */}
            <Typography>
                {pagesCount} pages
            </Typography>

            <TextField
                size="small"
                value={pageInput}
                placeholder="Page"
                onChange={(e) =>
                    setPageInput(e.target.value)
                }
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        const page = Number(pageInput);

                        if (!isNaN(page)) {
                            onGoToPage(page);
                        }
                    }
                }}
                sx={{
                    width: 80,
                    ml: 2,
                    "& input": {
                        color: "#fff",
                        py: 1,
                    },
                }}
            />

            <Typography sx={{ opacity: 0.8 }}>
                / {pagesCount}
            </Typography>

            <Typography sx={{ ml: 1, fontWeight: 600 }}>
                Page {currentPage}
            </Typography>

            {/* ZOOM CONTROLS */}
            <IconButton onClick={onZoomIn} sx={{ color: "#fff", ml: 2 }}>
                <ZoomIn />
            </IconButton>

            <IconButton onClick={onZoomOut} sx={{ color: "#fff" }}>
                <ZoomOut />
            </IconButton>

            <Typography>
                {Math.round(zoom * 100)}%
            </Typography>

            {/* POSITION CONTROL */}
            <IconButton
                onClick={onResetPosition}
                title="Reset position"
                sx={{ color: "#fff", ml: 2 }}
            >
                <CenterFocusStrong />
            </IconButton>
        </Box>
    );
}

PdfToolbar.propTypes = {
    pagesCount: PropTypes.number,
    zoom: PropTypes.number,
    pageInput: PropTypes.string,
    setPageInput: PropTypes.func,
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
    onGoToPage: PropTypes.func,
    onResetPosition: PropTypes.func,
    currentPage: PropTypes.number,
};